import { render, staticRenderFns } from "./Favorates.vue?vue&type=template&id=28f324a3&scoped=true&"
import script from "./Favorates.vue?vue&type=script&lang=js&"
export * from "./Favorates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f324a3",
  null
  
)

export default component.exports